window.$ && $(document).ready(function() {
  productVideoOpen();
  filterFaqMethod();
  observeElementRender('#ShopifyChat', () => {
    $(document).on('click', '.formContactUs .contact-support-content-left .contact-support-content-top', function() {
      openChat();
    })
  });
  if ($(window).width() < 990) {
    $('.footer-layout .footer_menu .title-block .f_btn_sl').removeClass('d-none');
    $('.footer-layout .footer_menu .block-content').hide();
    $('.footer-layout .footer_menu').eq(0).find('.title-block .f_btn_sl').addClass('active');
    $('.footer-layout .footer_menu').eq(0).find('.block-content').show();
  }
})

function productVideoOpen() {
  const url = $('#PageContainer .modal-content-video .video-iframe').attr('src');
  const width1 = $(window).width();
  const height1 = $(window).height();
  const height2 = parseInt(height1) - 40
  $(document).on('click', '#PageContainer .video-image .video-image-btn', function() {
    $('#PageContainer .modal-content-video').addClass('open');
    $('#PageContainer .modal-video-overlay').addClass('modal-video-overlay-show');
    $('#PageContainer .modal-content-video .video-iframe').attr('src', url);
    if ($(window).width() > 990) {
      $('#PageContainer .modal-content-video .video-iframe').css('width', width1+'px').css('height', height2+'px')
    }
    $('body').css('overflow', 'hidden');
  })
  $(document).on('click', '#PageContainer .modal-content-video .modal__close-button', function() {
    $('#PageContainer .modal-content-video').removeClass('open');
    $('#PageContainer .modal-video-overlay').removeClass('modal-video-overlay-show');
    $('body').css('overflow', 'auto');
  })
}

function filterFaqMethod(){
 $(document).on('change', '.page-faqs .faq-search .faq-search__input', function() {
  const fagValue = $(this).val();
  const fagValueChange = fagValue.trim().toLowerCase();
  const faqItem = $('.page-faqs .faqPageWrapper .faq-search-item');
  if (fagValue) {
    for(let i=0; i < faqItem.length; i++) {
      console.log($(faqItem[i]).text())
      const textName = $(faqItem[i]).text();
      $(faqItem[i]).removeClass('hideItem')
      if (textName.indexOf(fagValue) == -1) {
        $(faqItem[i]).addClass('hideItem')
      }
    }
  } else {
    faqItem.removeClass('hideItem');
  }
 })
}

function observeElementRender(selector, callback) { // 监听元素是否加载
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector(selector)) {
      callback();
      obs.disconnect(); // 停止观察避免内存泄漏
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function openChat() { // 聊天插件样式控制
  setTimeout(function() {
    const chatDom = document.getElementById("ShopifyChat") ||  null ;
    const chatDom1 = chatDom ? chatDom.shadowRoot : null;
    if (chatDom1) {
      const chatDom2 = chatDom1.querySelector('.chat-toggle');
      chatDom2.click();
    }
  }, 300)
}